import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CartItem } from 'models/cartItem';

@Component({
    selector: 'da-hotels-list',
    templateUrl: './hotels-list.component.html',
    styleUrls: ['./hotels-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HotelsListComponent implements OnInit {
    @Input() events: CartItem[];
    public haveHotels: boolean = false;
    public locationsList: string[];
    public cityList: string[];
    constructor() {}

    ngOnInit() {
        this.locationsList = [];
        this.cityList = [];
        if (this.events) {
            this.events.forEach((event) => {
                if (event.location && event.location.hotels && event.location.hotels.length > 0) {
                    this.haveHotels = true;

                    if (this.cityList.indexOf(event.location.city) === -1) {
                        this.cityList.push(event.location.city);
                        this.locationsList.push(event.location);
                    }
                }
            });
        }
    }
}
